import React, { useRef, useEffect } from 'react';
import Slider from '../../../Static/javascript/modules/slider';


export interface SliderProps {
    layout?: string;
    count?: number;
    dots?: boolean;
    children?: React.ReactNode;
}

export const CitationSlider = ({ layout = '', count = 4, dots = false, children, ...props }: SliderProps) => {
    const sliderContainer = useRef<HTMLDivElement>(null);
    let sliderComponent = useRef<Slider | null>(null);

    useEffect(() => {
        // Remove the old slider instance and create a new one when the controls have changed
        if (sliderComponent.current) {
            sliderComponent.current.cleanup();
            sliderComponent.current = new Slider(sliderContainer.current as HTMLElement, dots);
        }
        else {
            sliderComponent.current = new Slider(sliderContainer.current as HTMLElement, dots);
        }
    }, [layout, count, dots]);

    // Convert children to array to handle both single and multiple children
    const childrenArray = React.Children.toArray(children);

    return (
        <div className="slider" role="region" aria-label="browse options" tabIndex={0} ref={sliderContainer}>
            <ul className="slider-controls" aria-label="slider controls" data-controls hidden>
                <li>
                    <button data-slider-prev aria-hidden="true" className="slider-control prev" type="button" aria-label="previous"><svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xlinkHref="#icon-chevron-down"></use>
                    </svg></button>
                </li>
                <li>
                    <button data-slider-next className="slider-control next" type="button" aria-label="next"><svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xlinkHref="#icon-chevron-down"></use>
                    </svg></button>
                </li>
            </ul>
            <ul data-slider-track className={`slider-track ${layout == 'narrow' ? 'slider-dense' : ''}`}>
                {
                    childrenArray.length > 0 ? (
                        childrenArray.map((child, index) => (
                            <li className="slider-item" key={index}>
                                {child}
                            </li>
                        ))
                    ) : (
                        [...Array(count)].map((_, index) => (
                            <li className="slider-item" key={index}>
                                {/* Empty slide - can be used for placeholder content */}
                            </li>
                        ))
                    )
                }
            </ul>
        </div>
    )
}